<template>
  <div id="support">
    <div class="">
      <ol class="breadcrumb">
        <li>
          <a href="#/dashboard">Dashboard</a>
        </li>
        <li class="active">
          <a>Manage Sales Resources</a>
        </li>
      </ol>
    </div>

    <div class="content login" v-loading="loading">
      <div class="cell">
        <div class="container pb100">
          <div class="row mt20">
            <p class="sub-title text-center">Manage Sales Resources</p>

            <div class="col-xs-12 mb20">
              <div class="panel-group" id="accordion">
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingOne">
                    <h4
                      class="panel-title collapsed"
                      role="button"
                      data-toggle="collapse"
                      href="#collapseOne"
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Add sales documentation list"
                        placement="top"
                      >
                        <a href="#" data-toggle="modal" data-target="#sales">
                          <span
                            class="iconfont2 icon-g7 button-icon mr20"
                          ></span>
                        </a> </el-tooltip
                      >SALES DOCUMENTATION
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseOne"
                    class="panel-collapse collapse"
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w15">List Name</th>
                          <th class="text-center w30"></th>
                        </tr>
                        <tbody>
                          <tr
                            v-for="(i, index) in sales_documentation"
                            :key="index"
                          >
                            <td class>{{ i.name }}</td>
                            <td class="text-right w30">
                              <a @click="open_sales(i)" class="black mr20"
                                >Open</a
                              >
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Edit"
                                placement="top"
                              >
                                <a
                                  class="black mr20"
                                  data-toggle="modal"
                                  data-target="#sales"
                                  @click="
                                    sales = Object.assign({}, i);
                                    isSalesEdit = true;
                                  "
                                >
                                  <span
                                    class="iconfont3 icon-edit font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Delete"
                                placement="top"
                              >
                                <a
                                  class="black"
                                  @click="delete_sales(i._id, i.name)"
                                >
                                  <span
                                    class="iconfont3 icon-delete font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingTwo">
                    <h4
                      class="panel-title collapsed"
                      role="button"
                      data-toggle="collapse"
                      href="#collapseTwo"
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Add files"
                        placement="top"
                      >
                        <a href="#" data-toggle="modal" data-target="#downloads">
                          <span
                            class="iconfont2 icon-g7 button-icon mr20"
                          ></span>
                        </a> </el-tooltip
                      >DOWNLOADS
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseTwo"
                    class="panel-collapse collapse"
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w15">Name</th>
                          <th class="text-center w30"></th>
                        </tr>
                        <tbody>
                          <tr
                            v-for="(i, index) in downloads"
                            :key="index"
                          >
                            <td class>{{ i.name }}</td>
                            <td class="text-right w30">
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="View file"
                                placement="top"
                              >
                                <a
                                  class="black mr20"
                                  target="_blank"
                                  :href="
                                    (typeof i.file_name != 'undefined' && i.file_name != '') ? $store.state.serverURL + '/' + i.file_name : i.url
                                  "
                                >
                                  <span
                                    class="iconfont3 icon-view font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Edit"
                                placement="top"
                              >
                                <a
                                  class="black mr20"
                                  data-toggle="modal"
                                  data-target="#downloads"
                                  @click="
                                    downloadModel = Object.assign({}, i);
                                    isDownloadModelEdit = true;
                                  "
                                >
                                  <span
                                    class="iconfont3 icon-edit font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Delete"
                                placement="top"
                              >
                                <a
                                  class="black"
                                  @click="delete_download(i._id, i.name)"
                                >
                                  <span
                                    class="iconfont3 icon-delete font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingThree">
                    <h4
                      class="panel-title collapsed"
                      role="button"
                      data-toggle="collapse"
                      href="#collapseThree"
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Add new video"
                        placement="top"
                      >
                        <a href="#" data-toggle="modal" data-target="#video">
                          <span
                            class="iconfont2 icon-g7 button-icon mr20"
                          ></span>
                        </a> </el-tooltip
                      >TUTORIALS AND VIDEOS
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseThree"
                    class="panel-collapse collapse"
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w15">Name</th>
                          <th>URL</th>
                          <th class="text-right w30"></th>
                        </tr>
                        <tbody>
                          <tr v-for="(i, index) in videos" :key="index">
                            <td class>{{ i.name }}</td>
                            <td class>{{ i.url }}</td>
                            <td class="text-right w30">
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Edit"
                                placement="top"
                              >
                                <a
                                  class="black mr20"
                                  data-toggle="modal"
                                  data-target="#video"
                                  @click="
                                    video = Object.assign({}, i);
                                    isVideoEdit = true;
                                  "
                                >
                                  <span
                                    class="iconfont3 icon-edit font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Delete"
                                placement="top"
                              >
                                <a
                                  class="black"
                                  @click="delete_video(i._id, i.name)"
                                >
                                  <span
                                    class="iconfont3 icon-delete font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modals -->

    <div
      class="modal"
      id="downloads"
      tabindex="-1"
      role="dialog"
      aria-labelledby
      data-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close"
            @click="downloads_close"
            aria-label="Close"
          >
            <i class="el-icon-close"></i>
          </button>
          <div class="modal-body">
            <p class="font18 text-center">DOWNLOADS FORM</p>
            <div class="row">
              <div class="col-sm-10 col-sm-offset-1">
                <el-form
                  :model="downloadModel"
                  ref="downloads"
                  status-icon
                  :rules="downloadRules"
                  validate-on-rule-change
                >
                  <table class="table mt30 font12">
                    <tr>
                      <td>Name</td>
                      <td>
                        <el-form-item
                          class="white"
                          prop="name"
                          :rules="[
                            { required: true, message: 'Name is required!' },
                          ]"
                        >
                          <el-input v-model="downloadModel.name" size="big"></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-middle">Thumbnail image</td>
                      <td class="text-right">
                        <el-form-item
                          class="white"
                          prop="image_file_name"
                          :rules="[
                            {
                              required: !isDownloadModelEdit,
                              message: 'Image is required!',
                            },
                          ]"
                        >
                          <div class="center">
                            <img
                              style="width: 100%"
                              id="download_preview"
                              ref="download_preview"
                              :src="download_thumbnail_url"
                              alt="your image"
                            />
                          </div>
                          <el-input
                            type="file"
                            id="download_image_file"
                            v-model="downloadModel.image_file_name"
                            @input="handle_download_file_upload"
                          ></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td>URL</td>
                      <td>
                        <el-form-item
                          class="white"
                          prop="url"
                        >
                          <el-input v-model="downloadModel.url" size="big"></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-middle">File</td>
                      <td class="text-right">
                        <el-form-item
                          class="white"
                          prop="file_name"
                        >
                          <el-input
                            type="file"
                            id="downloads_file"
                            v-model="downloadModel.file_name"
                          ></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                  </table>
                </el-form>
                <div class="mt50 text-center">
                  <button
                    type="button"
                    @click="downloads_close()"
                    class="el-button mr20"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="el-button el-button--primary"
                    @click="downloads_submit()"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- SALES MODAL -->
    <div
      class="modal"
      id="sales"
      tabindex="-1"
      role="dialog"
      aria-labelledby
      data-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <i class="el-icon-close"></i>
          </button>
          <div class="modal-body">
            <p class="font18 text-center">SALES DOCUMENTATION FORM</p>
            <div class="row">
              <div class="col-sm-10 col-sm-offset-1">
                <el-form
                  :model="sales"
                  ref="sales"
                  status-icon
                  validate-on-rule-change
                >
                  <table class="table mt30 font12">
                    <tr>
                      <td>Name</td>
                      <td>
                        <el-form-item
                          class="white"
                          prop="name"
                          :rules="[
                            { required: true, message: 'Name is required!' },
                          ]"
                        >
                          <el-input v-model="sales.name" size="big"></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                  </table>
                </el-form>
                <div class="mt50 text-center">
                  <button
                    type="button"
                    @click="sales_close()"
                    class="el-button mr20"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="el-button el-button--primary"
                    @click="sales_submit()"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- VIDEO MODAL -->
    <div
      class="modal"
      id="video"
      tabindex="-1"
      role="dialog"
      aria-labelledby
      data-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close"
            @click="video_close"
            aria-label="Close"
          >
            <i class="el-icon-close"></i>
          </button>
          <div class="modal-body">
            <p class="font18 text-center">VIDEO FORM</p>
            <div class="row">
              <div class="col-sm-10 col-sm-offset-1">
                <el-form
                  :model="video"
                  ref="video"
                  status-icon
                  validate-on-rule-change
                >
                  <table class="table mt30 font12">
                    <tr>
                      <td>Name</td>
                      <td>
                        <el-form-item
                          class="white"
                          prop="name"
                          :rules="[
                            { required: true, message: 'Name is required!' },
                          ]"
                        >
                          <el-input v-model="video.name" size="big"></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-middle">Thumbnail image</td>
                      <td class="text-right">
                        <el-form-item
                          class="white"
                          prop="file_name"
                          :rules="[
                            {
                              required: !isVideoEdit,
                              message: 'Image is required!',
                            },
                          ]"
                        >
                          <div class="center">
                            <img
                              style="width: 100%"
                              id="video_preview"
                              ref="video_preview"
                              :src="video_thumbnail_url"
                              alt="your image"
                            />
                          </div>
                          <el-input
                            type="file"
                            id="video_file"
                            v-model="video.file_name"
                            @input="handle_video_file_upload"
                          ></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-middle">URL</td>
                      <td class="text-right">
                        <el-form-item
                          class="white"
                          prop="url"
                          :rules="[
                            { required: true, message: 'URL is required!' },
                          ]"
                        >
                          <el-input v-model="video.url" size="big"></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                  </table>
                </el-form>
                <div class="mt50 text-center">
                  <button
                    type="button"
                    @click="video_close()"
                    class="el-button mr20"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="el-button el-button--primary"
                    @click="video_submit()"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.panel-title {
  height: 60px;
}
.modal-content {
  padding: 28px;
}
</style>
<script>
import axios from "axios";
export default {
  name: "sales-resources-manage",
  data() {
    var requiredIf = (rule, value, callback) => {
      if (this.isDownloadModelEdit) {
        callback();
        return;
      }
      var filledValues = [this.downloadModel.url, this.downloadModel.file_name].map((value) => String(value || '').trim()).filter(Boolean).length;
      if (filledValues == 0) {
        callback(new Error("File URL or File is Required"));
      } else if (filledValues == 2) {
        callback(new Error("Only File URL or File can be entered"));
      }
      else {
        callback();
      }
    };
    return {
      video: {},
      videos: [],
      sales: {},
      sales_documentation: [],
      loading: true,
      downloadModel: {},
      downloads: [],
      video_image_file: "",
      video_thumbnail_url: "",
      download_image_file: "",
      download_thumbnail_url: "",
      isSalesEdit: false,
      isDownloadModelEdit: false,
      isVideoEdit: false,
      downloadRules: {
        url: [{ validator: requiredIf }],
        file_name: [{ validator: requiredIf }],
      },
    };
  },
  watch: {
    isDownloadModelEdit(newVal) {
      if (newVal) {
        this.download_thumbnail_url =
          this.$store.state.serverURL +
          "/" +
          this.downloadModel.image_file_name +
          "?" +
          Date.now();
        this.downloadModel.image_file_name = "";
        this.downloadModel.file_name = "";
      } else {
        this.download_thumbnail_url = "";
      }
    },
    isVideoEdit(newVal) {
      if (newVal) {
        this.video_thumbnail_url =
          this.$store.state.serverURL +
          "/" +
          this.video.file_name +
          "?" +
          Date.now();
        this.video.file_name = "";
      } else {
        this.video_thumbnail_url = "";
      }
    },
  },
  methods: {
    handle_download_file_upload() {
      this.download_image_file =
        document.getElementById("download_image_file").files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.download_preview.setAttribute("src", e.target.result);
      };
      reader.readAsDataURL(this.download_image_file); // convert to base64 string
    },
    downloads_close() {
      window.$("#downloads").modal("hide");
      this.$refs.downloads.resetFields();
      this.$refs.download_preview.setAttribute("src", "");
      this.isDownloadModelEdit = false;
      this.downloadModel = {};
      this.loading = false;
    },
    downloads_submit() {
      this.$refs.downloads.validate((valid) => {
        if (valid) {
          var downloads_file;
          this.loading = true;
          let formData = new FormData();
          if (this.download_image_file instanceof File) {
            formData.append("image_file", this.download_image_file);
            downloads_file = document.getElementById("downloads_file").files[0];
          }
          if (downloads_file instanceof File) {
            formData.append("file", downloads_file);
          }
          for (var attr in this.downloadModel) {
            formData.append(attr, this.downloadModel[attr]);
          }
          if (this.isDownloadModelEdit) {
            this.edit_downloadModel(formData);
          } else {
            this.add_downloadModel(formData);
          }
        }
      });
    },
    add_downloadModel(formData) {
      axios
        .post("/support/sales/downloads/add/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(async (res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Created!",
            });
            this.downloads_close();
            var s = await this.get_downloads();
            this.downloads = s.data;
          } else {
            this.$message({
              type: "error",
              message: "Create Failed!",
            });
            this.downloads_close();
          }
        })
        .catch((error) => {
          alert(error);
          this.downloads_close();
        });
    },
    edit_downloadModel(formData) {
      axios
        .put("/support/sales/downloads/edit/" + this.downloadModel._id, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(async (res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Updated!",
            });
            this.downloads_close();
            var s = await this.get_downloads();
            this.downloads = s.data;
          } else {
            this.$message({
              type: "error",
              message: "Update Failed!",
            });
            this.downloads_close();
          }
        })
        .catch((error) => {
          alert(error);
          this.downloads_close();
        });
    },
    delete_download(id, name) {
      axios;
      const h = this.$createElement;
      this.$msgbox({
        title: "DELETE DOWNLOAD",
        message: h("p", null, [
          h("span", null, "Are you sure you want to delete "),
          h("span", { style: "color: red" }, name + "?"),
        ]),
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            axios
              .delete("/support/sales/downloads/delete/" + id)
              .then(async (res) => {
                if (res.data.ok == 1) {
                  this.$message({
                    type: "success",
                    message: "Deleted!",
                  });
                  done();
                  var s = await this.get_downloads();
                  this.downloads = s.data;
                } else {
                  this.$message({
                    type: "error",
                    message: "Delete Failed!",
                  });
                }
              })
              .catch((error) => {
                window.console.log(error);
              });
          } else {
            done();
          }
        },
      });
    },
    async get_downloads() {
      return await axios.get("/support/sales/downloads");
    },
    async get_sales_documentation() {
      return await axios.get("/support/sales");
    },
    delete_sales(id, name) {
      const h = this.$createElement;
      this.$msgbox({
        title: "DELETE SALES DOCUMENTATION LIST",
        message: h("p", null, [
          h("span", null, "Are you sure you want to delete "),
          h("span", { style: "color: red" }, name + " and all the files?"),
        ]),
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            axios
              .delete("/support/sales/delete/" + id)
              .then(async (res) => {
                if (res.data.ok == 1) {
                  this.$message({
                    type: "success",
                    message: "Deleted!",
                  });
                  done();
                  var t = await this.get_sales_documentation();
                  this.sales_documentation = t.data;
                } else {
                  this.$message({
                    type: "error",
                    message: "Delete Failed!",
                  });
                }
              })
              .catch((error) => {
                window.console.log(error);
              });
          } else {
            done();
          }
        },
      });
    },
    sales_submit() {
      this.$refs.sales.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.isSalesEdit) {
            axios
              .put("/support/sales/edit/" + this.sales._id, {
                sales: {
                  name: this.sales.name
                },
              })
              .then(async (res) => {
                if (res.data.ok == 1) {
                  this.$message({
                    type: "success",
                    message: "Updated!",
                  });
                  this.sales_close();
                  var t = await this.get_sales_documentation();
                  this.sales_documentation = t.data;
                } else {
                  this.$message({
                    type: "error",
                    message: "Update Failed!",
                  });
                  this.sales_close();
                }
              })
              .catch((error) => {
                alert(error);
                this.sales_close();
              });
          } else {
            axios
              .post("/support/sales/add/", {
                sales: {
                  name: this.sales.name
                },
              })
              .then(async (res) => {
                if (res.data.ok == 1) {
                  this.$message({
                    type: "success",
                    message: "Created!",
                  });
                  this.sales_close();
                  var t = await this.get_sales_documentation();
                  this.sales_documentation = t.data;
                } else {
                  this.$message({
                    type: "error",
                    message: "Create Failed!",
                  });
                  this.sales_close();
                }
              })
              .catch((error) => {
                alert(error);
                this.sales_close();
              });
          }
        }
      });
    },
    sales_close() {
      window.$("#sales").modal("hide");
      this.$refs.sales.resetFields();
      this.isSalesEdit = false;
      this.sales = {};
      this.loading = false;
    },
    open_sales(sales) {
      this.$router.push({
        name: "sales-resources-manage-tech",
        params: { editTech: sales },
      });
    },
    handle_video_file_upload() {
      this.video_file = document.getElementById("video_file").files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.video_preview.setAttribute("src", e.target.result);
      };
      reader.readAsDataURL(this.video_file); // convert to base64 string
    },
    async get_videos() {
      return await axios.get("/support/sales/videos");
    },
    video_close() {
      window.$("#video").modal("hide");
      this.$refs.video.resetFields();
      this.$refs.video_preview.setAttribute("src", "");
      this.isVideoEdit = false;
      this.video = {};
      this.loading = false;
    },
    add_video(formData) {
      axios
        .post("/support/sales/videos/add/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(async (res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Created!",
            });
            this.video_close();
            var v = await this.get_videos();
            this.videos = v.data;
          } else {
            this.$message({
              type: "error",
              message: "Create Failed!",
            });
            this.video_close();
          }
        })
        .catch((error) => {
          alert(error);
          this.video_close();
        });
    },
    edit_video(formData) {
      axios
        .put("/support/sales/videos/edit/" + this.video._id, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(async (res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Updated!",
            });
            this.video_close();
            var v = await this.get_videos();
            this.videos = v.data;
          } else {
            this.$message({
              type: "error",
              message: "Update Failed!",
            });
            this.video_close();
          }
        })
        .catch((error) => {
          alert(error);
          this.video_close();
        });
    },
    video_submit() {
      this.$refs.video.validate((valid) => {
        if (valid) {
          this.loading = true;
          let formData = new FormData();
          if (this.video_file instanceof File) {
            formData.append("file", this.video_file);
          }
          for (var attr in this.video) {
            formData.append(attr, this.video[attr]);
          }
          if (this.isVideoEdit) {
            this.edit_video(formData);
          } else {
            this.add_video(formData);
          }
        }
      });
    },
    delete_video(id, name) {
      axios;
      const h = this.$createElement;
      this.$msgbox({
        title: "DELETE VIDEO",
        message: h("p", null, [
          h("span", null, "Are you sure you want to delete "),
          h("span", { style: "color: red" }, name + "?"),
        ]),
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            axios
              .delete("/support/sales/videos/delete/" + id)
              .then(async (res) => {
                if (res.data.ok == 1) {
                  this.$message({
                    type: "success",
                    message: "Deleted!",
                  });
                  done();
                  var v = await this.get_videos();
                  this.videos = v.data;
                } else {
                  this.$message({
                    type: "error",
                    message: "Delete Failed!",
                  });
                }
              })
              .catch((error) => {
                window.console.log(error);
              });
          } else {
            done();
          }
        },
      });
    },
  },
  async mounted() {
    var r2 = this.get_sales_documentation();
    var r3 = this.get_downloads();
    var r4 = this.get_videos();
    var downloads = await r3
    var sales = await r2;
    var videos = await r4;
    this.downloads = downloads.data;
    this.sales_documentation = sales.data;
    this.videos = videos.data;
    this.loading = false;
  },
};
</script>

<style>
</style>
